import { Map as PigeonMap, Marker, Overlay, ZoomControl } from 'pigeon-maps';
import './Map.scss';

export function Map({
  center,
  location = 'My Location',
}: {
  center: [number, number];
  location?: string;
}) {
  return (
    <div data-component="Map" style={{ width: '100%', height: '100%' }}>
      <PigeonMap center={center} zoom={13}>
        <Marker
          anchor={center}
          onClick={() => {
            // Handle marker click if necessary
          }}
        />
        <Overlay anchor={center} offset={[12, 30]}>
          {/* Add additional content or controls as needed */}
        </Overlay>
      </PigeonMap>
    </div>
  );
}
